/* tslint:disable */
/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { SubmissionsStatistics } from '../../models/submissions-statistics';

export interface GetStatisticsForSubmissionsCyclesApiV2SubmissionsOrgSubmissionsCyclesStatisticsGet$Params {
  org: string;
}

export function getStatisticsForSubmissionsCyclesApiV2SubmissionsOrgSubmissionsCyclesStatisticsGet(http: HttpClient, rootUrl: string, params: GetStatisticsForSubmissionsCyclesApiV2SubmissionsOrgSubmissionsCyclesStatisticsGet$Params, context?: HttpContext): Observable<StrictHttpResponse<Array<SubmissionsStatistics>>> {
  const rb = new RequestBuilder(rootUrl, getStatisticsForSubmissionsCyclesApiV2SubmissionsOrgSubmissionsCyclesStatisticsGet.PATH, 'get');
  if (params) {
    rb.path('org', params.org, {});
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'application/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<Array<SubmissionsStatistics>>;
    })
  );
}

getStatisticsForSubmissionsCyclesApiV2SubmissionsOrgSubmissionsCyclesStatisticsGet.PATH = '/api/v2/submissions/{org}/submissions-cycles/statistics';
